export default __webpack_public_path__ + "static/media/back_side_facing_camera.f63ae66f.mp3";